import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, createUnknownComponentVNode as _$cc } from 'intact-vue';
import { Icon } from '../icon';
import { Ellipsis } from '../ellipsis';
import { getRestProps, findChildren, isComponentVNode } from '../utils';
import { makeTitleStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _$cn2;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var rootMenu = this.rootMenu;
  var _rootMenu$get = rootMenu.get(),
    collapse = _rootMenu$get.collapse;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-menu-title"] = true, _classNameObj[className] = className, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), _$ce(2, 'div', !collapse ? _$cc(Ellipsis, {
    'position': 'bottom',
    'children': children
  }) : findChildren(children, function (vNode) {
    return isComponentVNode(vNode, Icon);
  }), 0, _$cn((_$cn2 = {}, _$cn2[k + "-menu-name"] = true, _$cn2[makeTitleStyles(k)] = true, _$cn2))));
}
;